import { ROLES } from 'config/constants';

export const getConnectDescription = (userRole) => {
  switch (userRole) {
    case ROLES.SPONSOR:
    case ROLES.INACTIVE_SPONSOR:
      return 'You can leave a note for this Organization and let them know why you are connecting with them e.g. participate in a study, access an investigational product for compassionate use';
    case ROLES.RESEARCH_SITE:
    case ROLES.INACTIVE_RESEARCH_SITE:
      return 'You can leave a note for this Organisation and let them know why are you requesting access to their profile information.';
    default:
      return '';
  }
};
